import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="w-full h-[500px]">
                <img 
                  src="https://public.readdy.ai/ai/img_res/c35e48bf96ac05ef159361da8a49192b.jpg"
                  alt="About Us"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-8 -right-8 bg-white rounded-xl shadow-2xl p-6 max-w-xs">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-700 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-award-line text-3xl text-white"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-800">15+</div>
                  <div className="text-sm text-gray-600">سنوات من التميز</div>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-full text-sm font-semibold mb-6">
              من نحن
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 leading-tight">
              {t('aboutTitle')}
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              {t('aboutDescription')}
            </p>

            {/* Vision & Mission */}
            <div className="space-y-6 mb-8">
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-eye-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{t('ourVision')}</h3>
                  <p className="text-gray-600">{t('visionText')}</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-target-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-800 mb-2">{t('ourMission')}</h3>
                  <p className="text-gray-600">{t('missionText')}</p>
                </div>
              </div>
            </div>

            {/* Values */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              <div className="flex items-center gap-3 p-4 bg-white rounded-lg shadow-md">
                <i className="ri-check-line text-2xl text-blue-600"></i>
                <span className="font-semibold text-gray-800">{t('value1')}</span>
              </div>
              <div className="flex items-center gap-3 p-4 bg-white rounded-lg shadow-md">
                <i className="ri-check-line text-2xl text-blue-600"></i>
                <span className="font-semibold text-gray-800">{t('value2')}</span>
              </div>
              <div className="flex items-center gap-3 p-4 bg-white rounded-lg shadow-md">
                <i className="ri-check-line text-2xl text-blue-600"></i>
                <span className="font-semibold text-gray-800">{t('value3')}</span>
              </div>
              <div className="flex items-center gap-3 p-4 bg-white rounded-lg shadow-md">
                <i className="ri-check-line text-2xl text-blue-600"></i>
                <span className="font-semibold text-gray-800">{t('value4')}</span>
              </div>
            </div>

            <Link 
              to="/about"
              className="inline-flex items-center gap-2 px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              {t('learnMore')}
              <i className="ri-arrow-left-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}